import { useSearchParams } from "react-router";

import { ChangeEmailContent } from "@/modules/auth/components/change-email-content";

export default function ChangeEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token")?.trim() ?? null;

  return <ChangeEmailContent key={token ?? "missing"} token={token} />;
}
